import React from 'react'
import { Button, Card, CardContent, RichTextEditor } from '@/shared/ui'
import { getTermsText, setTermsText, getOpportunitiesNoticeText, setOpportunitiesNoticeText } from '../services/settingsService'

export default function TermsSettings() {
  const [checkoutTerms, setCheckoutTerms] = React.useState('')
  const [oppNotice, setOppNotice] = React.useState('')
  const [loading, setLoading] = React.useState(true)
  const [savingCheckout, setSavingCheckout] = React.useState(false)
  const [savingOpp, setSavingOpp] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)
  const [savedCheckout, setSavedCheckout] = React.useState(false)
  const [savedOpp, setSavedOpp] = React.useState(false)

  React.useEffect(() => {
    ;(async () => {
      try {
        const [t1, t2] = await Promise.all([getTermsText(), getOpportunitiesNoticeText()])
        setCheckoutTerms(t1)
        setOppNotice(t2)
      } catch (e: any) {
        setError(e?.message || 'Falha ao carregar')
      } finally {
        setLoading(false)
      }
    })()
  }, [])

  async function onSaveCheckout() {
    setSavingCheckout(true)
    setError(null)
    try {
      await setTermsText(checkoutTerms)
      setSavedCheckout(true)
    } catch (e: any) {
      setError(e?.message || 'Falha ao salvar termos de checkout')
    } finally {
      setSavingCheckout(false)
      setTimeout(() => setSavedCheckout(false), 1500)
    }
  }

  async function onSaveOppNotice() {
    setSavingOpp(true)
    setError(null)
    try {
      await setOpportunitiesNoticeText(oppNotice)
      setSavedOpp(true)
    } catch (e: any) {
      setError(e?.message || 'Falha ao salvar aviso de oportunidades')
    } finally {
      setSavingOpp(false)
      setTimeout(() => setSavedOpp(false), 1500)
    }
  }

  return (
    <div className="space-y-4">
      <h2 className="text-lg font-medium">Termos de acordo</h2>
      <p className="text-sm text-foreground/70">
        Edite os textos exibidos nos modais de termos do checkout e de aviso da página de Oportunidades.
      </p>
      {error && (
        <div className="rounded-md border border-destructive/30 bg-destructive/10 p-2 text-sm text-destructive-foreground">
          {error}
        </div>
      )}

      <Card>
        <CardContent className="pt-4">
          <h3 className="mb-2 text-sm font-medium">Termos de checkout</h3>
          <p className="mb-2 text-xs text-foreground/70">
            Conteúdo exibido no modal de termos durante o fluxo de cadastro/checkout.
          </p>
          <RichTextEditor value={checkoutTerms} onChange={setCheckoutTerms} />
          <div className="mt-3 flex items-center gap-2">
            <Button onClick={onSaveCheckout} disabled={savingCheckout || loading}>
              {savingCheckout ? 'Salvando...' : 'Salvar termos de checkout'}
            </Button>
            {savedCheckout && <div className="text-xs text-emerald-500">Salvo</div>}
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="pt-4">
          <h3 className="mb-2 text-sm font-medium">Aviso da página de Oportunidades</h3>
          <p className="mb-2 text-xs text-foreground/70">
            Texto exibido em um modal obrigatório na página de Oportunidades. O usuário precisa marcar que leu e está ciente
            para continuar vendo as oportunidades.
          </p>
          <RichTextEditor value={oppNotice} onChange={setOppNotice} />
          <div className="mt-3 flex items-center gap-2">
            <Button onClick={onSaveOppNotice} disabled={savingOpp || loading}>
              {savingOpp ? 'Salvando...' : 'Salvar aviso de oportunidades'}
            </Button>
            {savedOpp && <div className="text-xs text-emerald-500">Salvo</div>}
          </div>
        </CardContent>
      </Card>
    </div>
  )
}

